import { Autocomplete } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

const HeaderSearch = () => {
  const { t } = useTranslate();
  return (
    <Autocomplete
      placeholder={t('search.placeholder')}
      leftSection={<IconSearch size={16} stroke={1.5} />}
      data={['todo']}
      visibleFrom="xs"
    />
  );
};

export default HeaderSearch;
